'use client';

import Script from 'next/script';

export default function GoogleAnalytics() {

  return (
    <>
      <Script async src="https://www.googletagmanager.com/gtag/js?id=G-2Z4CQMV731" />
      <Script id="ga-gtag">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}

          gtag('js', new Date());
          gtag('consent', 'default', {
            'ad_storage': 'denied',
            'analytics_storage': 'denied'
          });
          gtag('config', 'G-2Z4CQMV731');
        `}
      </Script>
    </>
  );
}
